import CloseIcon from '@mui/icons-material/Close';
import { Box, BoxProps, Button, Modal as MUXModal, ModalProps as MuxProps, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

export interface ModalProps<TInnerComponent extends 'div' | 'form'> extends Omit<MuxProps, 'children'> {
  children?: ReactNode;
  footer?: ReactNode;
  header?: ReactNode;
  height?: number | string;
  innerComponent?: TInnerComponent;
  innerComponentProps?: BoxProps<TInnerComponent>;
  onClose?: () => void;
  showTopCloseButton?: boolean;
  width?: number | string;
}

export const Modal = <TInnerComponent extends 'div' | 'form'>(props: ModalProps<TInnerComponent>) => {
  const {
    children,
    footer,
    header,
    height,
    innerComponent = 'div',
    innerComponentProps,
    onClose,
    showTopCloseButton = true,
    width,
    ...rest
  } = props;

  return (
    <MUXModal
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      onClose={onClose}
      {...rest}
    >
      <Box
        component={innerComponent}
        sx={{
          bgcolor: 'background.paper',
          borderRadius: '8px',
          height: height,
          left: '50%',
          p: '32px',
          position: 'absolute',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          width: width,
        }}
        {...innerComponentProps}
      >
        <Stack>
          {showTopCloseButton ? (
            <Button
              aria-label="delete"
              sx={{ alignSelf: 'flex-end', display: 'flex', flexDirection: 'column', margin: 0, minWidth: 'auto' }}
              onClick={() => onClose?.()}
              color="inherit"
            >
              <CloseIcon />
            </Button>
          ) : null}
          <Stack gap={3}>
            <Typography
              fontWeight="bold"
              id="modal-modal-title"
              marginBottom={0}
              variant="subtitle1"
            >
              {header}
            </Typography>
            <Box>{children}</Box>
            {footer ? <Box>{footer}</Box> : null}
          </Stack>
        </Stack>
      </Box>
    </MUXModal>
  );
};
